import * as yup from 'yup';
import validateChemistryOther from './validateChemistryOther';

export default function registerValidation() {
  yup.addMethod(yup.string, 'validateChemistryOther', validateChemistryOther);
}
